import { render } from "./PodftAsideModalAppeal.vue?vue&type=template&id=7b11cdda"
import script from "./PodftAsideModalAppeal.vue?vue&type=script&lang=js"
export * from "./PodftAsideModalAppeal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__